/* eslint-disable react/jsx-filename-extension */
import {
  VIEW_SCHEDULER,
  VIEW_ADMIN,
  VIEW_CMS_PRICING,
  VIEW_ORGANIZATIONS,
  VIEW_ORDERS,
  VIEW_PRICING_ADMIN,
  VIEW_CLAIMS,
  VIEW_REPAIR_ORDER,
  SAFETY_MANAGER,
  READ_CUSTOMER_LOGINS,
} from 'shared/../constants/UserAccess';

const tableMaintList = [
  // pricing
  { userAccess: [VIEW_PRICING_ADMIN, VIEW_CMS_PRICING], section: 'pricing', path: 'invoice-line-item-types', text: 'Invoice Line Item Types' },
  { userAccess: [VIEW_PRICING_ADMIN, VIEW_CMS_PRICING], section: 'pricing', path: 'ratezones', text: 'Rate Zones' },
  { userAccess: [VIEW_PRICING_ADMIN, VIEW_CMS_PRICING], section: 'pricing', path: 'lane-rates', text: 'Late Rates' },
  { userAccess: VIEW_CMS_PRICING, section: 'pricing', path: 'standard-fuel-tariffs', text: 'Standard Fuel Tariffs' },
  { userAccess: [VIEW_PRICING_ADMIN, VIEW_CMS_PRICING], section: 'pricing', path: 'direct-standards', text: 'Direct Standards' },

  // scheduling
  { userAccess: VIEW_SCHEDULER, section: 'scheduling', path: 'scheduling-terminals', text: 'Scheduling Terminals' },
  { userAccess: VIEW_SCHEDULER, section: 'scheduling', path: 'customer-capacity', text: 'Customer Capacity' },

  // safety
  { userAccess: SAFETY_MANAGER, section: 'safety', path: 'drivers', text: 'Drivers' },
  { userAccess: SAFETY_MANAGER, section: 'safety', path: 'trucks', text: 'Trucks' },
  { userAccess: SAFETY_MANAGER, section: 'safety', path: 'driver-truck-assignments', text: 'Driver/Truck Assignments' },
  { userAccess: SAFETY_MANAGER, section: 'safety', path: 'owners', text: 'Owners' },
  { userAccess: SAFETY_MANAGER, section: 'safety', path: 'safety-table-maints/hazmat-classes', text: 'Hazmat Classes' },

  // claims / risk
  { userAccess: VIEW_CLAIMS, section: 'risk', path: 'insurance', text: 'Insurance' },

  // maintenance
  { userAccess: VIEW_REPAIR_ORDER, section: 'maintenance', path: 'repair-issues', text: 'Repair Issues' },
  { userAccess: VIEW_REPAIR_ORDER, section: 'maintenance', path: 'repair-categories', text: 'Repair Categories' },
  { userAccess: VIEW_REPAIR_ORDER, section: 'maintenance', path: 'gwi-equipment', text: 'GWI Equipment' },
  { userAccess: [VIEW_PRICING_ADMIN], section: 'maintenance', path: 'equipment-types', text: 'Equipment Types' },

  // organizations
  { userAccess: VIEW_ORGANIZATIONS, section: 'organizations', path: 'organizations', text: 'Organizations' },
  { userAccess: VIEW_ORGANIZATIONS, section: 'organizations', path: 'organizations-mapping', text: 'Legacy Organizations Mapping' },
  { userAccess: VIEW_ORGANIZATIONS, section: 'organizations', path: 'locations', text: 'Locations' },
  { userAccess: VIEW_ORGANIZATIONS, section: 'organizations', path: 'contacts', text: 'Contacts' },
  { userAccess: [VIEW_PRICING_ADMIN], section: 'organizations', path: 'per-diem-standard-tariffs', text: 'Per Diem Standard Tariffs' },
  { userAccess: [VIEW_PRICING_ADMIN], section: 'organizations', path: 'per-diem-contract-rules', text: 'Per Diem Contract Rules' },

  // admin
  { userAccess: READ_CUSTOMER_LOGINS, section: 'admin', path: 'customer-logins', text: 'Customer Logins' },
  { userAccess: VIEW_ADMIN, section: 'admin', path: 'users', text: 'Users' },
  { userAccess: VIEW_ADMIN, section: 'admin', path: 'integration-users', text: 'Integration Users' },
  { userAccess: VIEW_CMS_PRICING, section: 'admin', path: 'note-templates', text: 'Note Templates' },
  { userAccess: VIEW_ORDERS, section: 'admin', path: 'carrier-rates', text: 'Carrier Rates' },
  { userAccess: VIEW_ADMIN, section: 'admin', path: 'messaging-groups', text: 'Messaging Groups' },
  { userAccess: VIEW_ADMIN, section: 'admin', path: 'messaging-v2-groups', text: 'Messaging V2 Groups' },
  { userAccess: VIEW_ADMIN, section: 'admin', path: 'deductions', text: 'Deductions' },
  { userAccess: VIEW_ADMIN, section: 'admin', path: 'deferments', text: 'Deferment Payback Order' },
  { userAccess: VIEW_ADMIN, section: 'admin', path: 'dispatchers', text: 'Dispatchers' },
  { userAccess: VIEW_ADMIN, section: 'admin', path: 'gwi-move-contacts', text: 'GWI Move Contacts' },
  { userAccess: VIEW_ADMIN, section: 'admin', path: 'verticals', text: 'Verticals' },
  { userAccess: VIEW_ADMIN, section: 'admin', path: 'reschedule-reasons', text: 'Reschedule Reasons' },
  { userAccess: VIEW_ADMIN, section: 'admin', path: 'dispatch-decline-reasons', text: 'Dispatch Decline Reasons' },
  { userAccess: VIEW_ADMIN, section: 'admin', path: 'users-role-mapping', text: 'Role Mapping' },
  { userAccess: VIEW_ADMIN, section: 'admin', path: 'roles', text: 'Roles' },
  { userAccess: VIEW_ADMIN, section: 'admin', path: 'company-info', text: 'Company Info' },
  { userAccess: VIEW_ADMIN, section: 'admin', path: 'contact-types', text: 'Contact Types' },
  { userAccess: VIEW_ADMIN, section: 'admin', path: 'ports', text: 'Ports' },
  { userAccess: VIEW_ADMIN, section: 'admin', path: 'carriers', text: 'Carriers' },
  { userAccess: VIEW_ADMIN, section: 'admin', path: 'trace-terminals', text: 'Trace Terminals' },
  { userAccess: VIEW_ADMIN, section: 'admin', path: 'markets', text: 'Markets' },
  { userAccess: VIEW_ADMIN, section: 'admin', path: 'credit-terms', text: 'Credit Terms' },
  { userAccess: VIEW_ADMIN, section: 'admin', path: 'chassis-pools', text: 'Chassis Pools' },
  { userAccess: VIEW_ADMIN, section: 'admin', path: 'document-types', text: 'Document Types' },
  { userAccess: VIEW_ADMIN, section: 'admin', path: 'scheduled-tracing-table-maint', text: 'Scheduled Tracing Table Maint' },
  { userAccess: VIEW_ADMIN, section: 'admin', path: 'scac-empty-locations', text: 'Scac Empty Locations' },
  { userAccess: VIEW_ADMIN, section: 'admin', path: 'weight-rules', text: 'Weight Rules' },
  { userAccess: VIEW_ADMIN, section: 'admin', path: 'email-templates', text: 'Email Templates' },
  { userAccess: VIEW_ADMIN, section: 'admin', path: 'merge-tags', text: 'Email Template Merge Tags' },
  { userAccess: VIEW_ADMIN, section: 'admin', path: 'tenants', text: 'Tenants' },

];

export default tableMaintList;